import { HomepageBelowFoldExperimentData } from '@dtx-company/app/shared/code/src/components/Homepage/HomepageStaticContent/variants/types'
import { MarketingPageRoutes } from '@dtx-company/true-common/src/constants/routes'

export const HomePageBelowFoldData: HomepageBelowFoldExperimentData = [
  {
    primary: {
      header: 'How can I create a QR code for free?',
      subheader:
        'Follow these easy steps to generate a free Flowcode QR code, then scroll up to make your first code!'
    },
    items: [],
    slice_type: 'ways-to-use_carousel_1'
  },
  {
    items: [
      {
        image: {
          alt: 'Select Scan Destination',
          url: '/graphics/locg/LOCG_step1.png'
        },
        subheader: 'Select your scan destination',
        description:
          'Whether you want to figure out how to make a QR code for a website or send people to an online menu, Flowcode offers easy ways to connect people to digital destinations. Simply select your scan destination and paste the necessary website link where it says "Enter or paste a URL".',
        button_variant: 'Tertiary',
        image_alignment: 'Left'
      },
      {
        image: {
          alt: 'Colorful QR Code',
          url: '/graphics/locg/LOCG_step2.png'
        },
        subheader: 'Make it pop! Add color to your QR code',
        description:
          'Can a QR code be any color? With Flowcode, they can. Get creative and skip the black and white codes! Select from a range of colors to match your brand, personality, or marketing collateral. ',
        button_variant: 'Tertiary',
        image_alignment: 'Right'
      },
      {
        image: {
          alt: 'QR code shape',
          url: '/graphics/locg/LOCG_step3.png'
        },
        subheader: 'Choose your QR code shape',
        description:
          "Custom shape QR codes do exist — and they're available with Flowcode. Whether you want to build a code  in the shape of a circle or square, select either option for a custom shape to match your brand.",

        button_variant: 'Tertiary',
        image_alignment: 'Left'
      },
      {
        image: {
          alt: 'QR code with frame',
          url: '/graphics/locg/LOCG_step4.png'
        },
        subheader: 'Add a frame',
        description:
          'Boost the number of scans for your QR code by adding a frame with a CTA. QR codes with a CTA receive 2x the number of scans as traditional codes.',
        button_variant: 'Tertiary',
        image_alignment: 'Right'
      },
      {
        image: {
          alt: 'QR code with logo',
          url: '/graphics/locg/LOCG_step5.png'
        },
        subheader: 'Upload your logo',
        description:
          "If you’re searching for a QR code generator with logos, look no further. Upload your brand's logo and re-size it to fit your needs. Just make sure the file you upload is smaller than 5mb.",
        button_variant: 'Tertiary',
        image_alignment: 'Left'
      },
      {
        image: {
          alt: 'QR code PNG',
          url: '/graphics/locg/LOCG_step6.png'
        },
        subheader: 'Download your code!',
        description:
          'Now, it’s the fun part. After completing steps one through five, simply create an account with your Gmail, Facebook, or enter your email and password. Then, click “download”. Your QR code PNG will be waiting for you, but feel free to download your code as a JPG or SVG too.',
        button_variant: 'Tertiary',
        image_alignment: 'Right'
      }
    ],
    slice_type: 'large_product_card'
  },
  {
    items: [
      {
        image: {
          alt: 'QR code generator API',
          url: '/graphics/locg/AnalyticsAPI.png'
        },
        subheader: 'Access our QR code API',
        largeTitle: true,
        description:
          'Ready to make hundreds or thousands of QR codes at scale? By using our API, you can create codes in bulk, integrate the creation into your own systems, and view comprehensive analytics.',
        button_label: 'View the developer portal',
        button_variant: 'Primary',
        button_href: { url: 'https://developer.flowcode.com/documentation/flowcode-api' },
        image_alignment: 'Right'
      }
    ],
    slice_type: 'large_product_card'
  },
  {
    primary: {
      header: 'A QR code generator built for every industry',
      button_label: 'Create a Flowcode',
      buton_variant: 'Secondary'
    },
    items: [
      {
        image: {
          alt: 'QR code for real estate',
          url: '/graphics/locg/RealEstate.png'
        },
        testimonial_title: 'QR Codes for Real Estate Agents',
        text: 'QR codes for real estate are a hack you need to grow your business. Whether you want to drive buyers and sellers to listings fast or provide more info to customers with in-depth details, Flowcode QR codes can be added to your selling kit.',
        button_label: 'Learn more real estate tips',
        button_variant: 'Secondary',
        button_href: {
          url: 'https://www.flowcode.com/industries/real-estate',
          target: '_blank'
        }
      },
      {
        image: {
          alt: 'Web3 QR code',
          url: '/graphics/locg/Web3.png'
        },
        testimonial_title: 'QR Codes for Web3',
        text: 'The Metaverse is being accessed with QR codes — are you coming? From providing secure access to digital assets to facilitating frictionless sharing of NFTs, QR codes for Web3 need to be apart of your business strategy.',
        button_label: 'Explore solutions for Web3',
        button_variant: 'Secondary',
        button_href: {
          url: 'https://www.flowcode.com/industries/web3',
          target: '_blank'
        }
      },
      {
        image: {
          alt: 'QR code for events',
          url: '/graphics/locg/Event.png'
        },
        testimonial_title: 'QR Codes for Events',
        text: 'Planning an event soon? Leverage Flowcode QR codes to make it a more seamless operation by securely checking in guests, connecting people to online merchandise, sharing program information, and so much more.',
        button_label: 'Get QR codes for events',
        button_variant: 'Secondary',
        button_href: {
          url: 'https://www.flowcode.com/use-case/event-registration-and-ticketing',
          target: '_blank'
        }
      },
      {
        image: {
          alt: 'QR code for designers',
          url: '/graphics/locg/Freelancer.png'
        },
        testimonial_title: 'QR Codes for Designers',
        text: 'Elevate your product with Flowcode QR codes. With artistic designs and customizable functionality, Flowcodes can quickly drive people to any virtual destination in style.',
        button_label: 'Learn how designers use QR code',
        button_variant: 'Secondary',
        button_href: {
          url: 'https://www.flowcode.com/teams/design-and-creative',
          target: '_blank'
        }
      },
      {
        image: {
          alt: 'QR codes for marketers',
          url: '/graphics/locg/Marketing.png'
        },
        testimonial_title: 'QR Codes for Marketers',
        text: 'Flowcode QR codes help you connect with customers at scale customers. Leverage QR to rapidly connect scanners to online stores, social profiles, sweepstakes, promos, and more. Drive conversions while you collect CRM and gather information about your customers in the offline world. ',
        button_label: 'Elevate your marketing',
        button_variant: 'Secondary',
        button_href: {
          url: 'https://www.flowcode.com/teams/marketing',
          target: '_blank'
        }
      }
    ],
    slice_type: 'testimonials_carousel'
  },
  {
    primary: {
      header: 'Discover unique uses for QR codes',
      button_label: 'Design your Flowcode',
      buton_variant: 'Secondary'
    },
    items: [
      {
        image: {
          alt: 'QR codes for app downloads',
          url: '/graphics/locg/UseCaseAppDownload.jpg'
        },
        testimonial_title: 'QR Codes for App Downloads',
        text: 'Pushing an app to new users and want a rapid way to distribute it? Use Flowcode QR codes! With one scan of a smartphone, users can be automatically directed to either the Apple or Android app store depending on their device type.',
        button_label: 'Create a code for your app',
        button_variant: 'Secondary',
        button_href: {
          url: 'https://www.flowcode.com/use-case/app-downloads',
          target: '_blank'
        }
      },
      {
        image: {
          alt: 'CRM QR code',
          url: '/graphics/locg/UseCaseCollectingCRM.jpg'
        },
        testimonial_title: 'QR Codes for CRM',
        text: 'Looking to collect more contacts? Flowcode QR codes can seamlessly support your efforts to build your marketing database. One scan of a code can automatically integrate to your CRM of choice like Hubspot, Mailchimp, Klavyio, and more.',
        button_label: 'Collect more contacts',
        button_variant: 'Secondary',
        button_href: {
          url: 'https://www.flowcode.com/product/integrations',
          target: '_blank'
        }
      },
      {
        image: {
          alt: 'QR codes product packaging ',
          url: '/graphics/locg/UseCaseProductPackaging.jpg'
        },
        testimonial_title: 'QR Codes for Product Packaging',
        text: 'QR codes on products allow you to educate buyers about your product, drive people to website, and communicate information about materials with just one scan!',
        button_label: 'Strengthen your product visibility',
        button_variant: 'Secondary',
        button_href: {
          url: 'https://www.flowcode.com/industries/consumer-packaged-goods',
          target: '_blank'
        }
      }
    ],
    slice_type: 'testimonials_carousel'
  },
  {
    primary: {
      header: 'Benefits of using QR codes',
      button_label: 'Make your own Flowcode',
      buton_variant: 'Secondary'
    },
    items: [
      {
        image: {
          alt: 'QR codes TV',
          url: '/graphics/locg/TV.png'
        },
        testimonial_title: 'Collect first party data',
        text: 'QR codes on TV help you capture first party data you previously never had access to. Flowcode QR codes in your commercial or digital campaign lets scanners instantly connect with any digital destination you’re trying to promote. When someone scans your code they get directed to the location of your choice, and you get details on the time of scan and device type.',
        button_label: 'Own your data',
        button_variant: 'Secondary',
        button_href: {
          url: 'https://www.flowcode.com/product/analytics',
          target: '_blank'
        }
      },
      {
        image: {
          alt: 'QR code label',
          url: '/graphics/locg/Retail.png'
        },
        testimonial_title: 'Educate customers',
        text: 'Flowcode QR codes send customers to any online destination, so it’s common for brands to use them as educational tools. Send customers to your company story, information about product materials, or even where they can buy your product in town!  Put a QR code on a product, a label, or a piece of clothing and see the impact of giving your customers more ways to explore your digital channels.',
        button_label: 'Teach your customers',
        button_variant: 'Secondary',
        button_href: {
          url: 'https://www.flowcode.com/use-case/personalized-and-interactive-experiences',
          target: '_blank'
        }
      },
      {
        image: {
          alt: 'Get more google reviews',
          url: '/graphics/locg/UseCaseCollectingSurveys.jpg'
        },
        testimonial_title: 'Collect more reviews',
        text: 'Want to get more Google reviews for your business? Flowcode QR codes make the process frictionless. Put a QR code on a receipt, on your store window, or on a packaging insert with your online store order. By adding the review site website to your QR code, you can send scanners directly to a place to give feedback (and get more 5 star reviews)!',
        button_label: 'Get 5 stars',
        button_variant: 'Secondary',
        button_href: {
          url: 'https://www.flowcode.com/use-case/user-generated-content-and-reviews',
          target: '_blank'
        }
      }
    ],
    slice_type: 'testimonials_carousel'
  },
  {
    items: [
      {
        image: {
          alt: 'High converting QR code',
          url: '/graphics/locg/Highest-converting-qr-code.jpg'
        },
        subheader: 'The highest converting QR code on the market',
        largeTitle: true,
        description:
          'Due to different shapes, colors, and patterns, Flowcodes get 18% higher scans than other QR code generator platforms. In order to stand out from the pack and get more scans, customization is key!',
        image_alignment: 'Left'
      }
    ],
    slice_type: 'large_product_card'
  },
  {
    primary: {
      subheader: 'Trusted by people and businesses around the world',
      image: {
        alt: 'Trusted by people and businesses around the world',
        url: '/graphics/locg/Businesses.png'
      }
    },
    slice_type: 'contact_sales_page_used_by_footer'
  },
  {
    primary: {
      heading: 'Free QR code generator with the best features'
    },
    items: [
      {
        title: 'Fully customizable QR code',
        description:
          'Flowcode lets you customize every feature of your QR code. Whether you want to change the pattern of your code, the color, or image inside the code, Flowcode gives you control to customize your QR code to match your brand. So, believe it or not, pretty QR codes do exist!'
      },
      {
        title: 'Beautiful QR code designs',
        description:
          'Well designed QR codes get 18% more engagement than standard black and white codes. If you’re looking for even more customization of your code, you can work with one of Flowcode’s in-house artists to make a code. We have designed custom codes for BMW, the NBA, ESPN, and thousands of businesses that want to stand out from the pack! '
      },
      {
        title: 'Advanced QR code analytics',
        description:
          'What information can you get when someone scans a Flowcode QR code that you create?  Details about the time of scan, device type, and zip code are all information you can analyze. At Flowcode, we call the information you get “Flowlytics”, and it’s all real-time data. That means the moment you get a scan, you know. This is why Flowcode has the most powerful analytics tool of any QR code provider.'
      },
      {
        title: 'The safest QR code on the market',
        description:
          'Flowcode is the most secure  QR code provider on the market. We take your privacy seriously, and back it up with the top certifications necessary to ensure anyone scanning the code you create is protected. With GDPR and CCPA compliance, Flowcode protects your business and your customers.'
      }
    ],
    slice_type: 'accordion'
  },
  {
    primary: {
      header: 'What can be done with QR codes?',
      subheader:
        'QR codes can be used in hundreds of ways, but the most popular methods are sending people to digital destinations like PDFs, websites, or phone numbers.'
    },
    items: [],
    slice_type: 'ways-to-use_carousel_1'
  },
  {
    items: [
      {
        image: {
          alt: 'QR code to a PDF',
          url: '/graphics/locg/pdf-to-qr-code.png'
        },
        subheader: 'PDF to QR code',
        largeTitle: true,
        description:
          "QR codes can send scanners to any PDF, like restaurant menus or instructional guides. Wondering how to make a QR code for a PDF? Using Flowcode's free qr code generator you can easily upload your PDF and create a free QR code.",
        button_label: 'Read about QR codes for PDFs',
        button_variant: 'Secondary',
        button_href: {
          url: 'https://www.flowcode.com/blog/how-to-connect-a-qr-code-to-a-pdf'
        },
        image_alignment: 'Left'
      },
      {
        image: {
          alt: 'QR code sticker',
          url: '/graphics/locg/qr-code-sticker.png'
        },
        subheader: 'QR code sticker',
        largeTitle: true,
        description:
          'Want to print your QR code as a sticker and get it into the real world? Whether you want to make an Instagram QR code sticker or a Venmo QR code sticker, Flowcode lets you create a QR code for free and then print',
        button_label: 'Make a QR code sticker',
        button_variant: 'Secondary',
        button_href: {
          url: 'https://www.flowcode.com/blog/printing-your-flowcode'
        },
        image_alignment: 'Right'
      },
      {
        image: {
          alt: 'QR code sign',
          url: '/graphics/locg/qr-code-sign.jpg'
        },
        subheader: 'Create a QR code sign',
        largeTitle: true,
        description:
          'When you create a QR code for your sign, billboard, or packaging you can track the effectiveness of your offline campaigns and evaluate the return of investment.',
        button_label: 'Learn more about QR code signs',
        button_variant: 'Secondary',
        button_href: {
          url: 'https://www.flowcode.com/use-case/offline-media-and-print-attribution'
        },
        image_alignment: 'Right'
      }
    ],
    slice_type: 'large_product_card'
  },
  {
    primary: {
      heading: 'FAQs about QR codes and QR code generators',
      cta1_img: {
        alt: 'Get help',
        url: '/graphics/locg/handshake.svg'
      },
      cta1_line1: 'Still have questions?',
      cta1_line2: 'Talk with an expert →',
      cta1_line2_href: MarketingPageRoutes.CONTACT_SALES,
      cta2_img: {
        alt: 'Help center',
        url: '/graphics/locg/help_center.svg'
      },
      cta2_line1: 'Visit our help center for more info',
      cta2_line2: 'Visit help center →',
      cta2_line2_href: 'https://support.flowcode.com/'
    },
    items: [
      {
        question: 'What is a QR code?',
        answer:
          'A QR code (short for Quick Response code) is a two-dimensional barcode that can be scanned by camera-equipped device such as Apple or Android smartphones. QR codes can store a range of information. From website URLs and contact information to product details and social profiles, QR codes are often used for marketing and advertising purposes. There are many companies that produce QR codes, but Flowcode has the strongest features and offerings for businesses and creators of all sizes.'
      },
      {
        question: 'What are the benefits of QR Codes?',
        answer:
          "At their core, QR codes offer a convenient way for rapid connection, and connect the offline world to digital destinations. If you're a business, you can use  QR codes to promote products, collect contacts, provide customers with access to discounts, and more! For individuals creators, QR codes can be used to access websites, share contact information, and connect with businesses rapidly. QR codes are also more secure than traditional barcodes, making them useful for tasks such as transferring tickets and tracking inventory. When it comes down to it, QR codes are extremely versatile products that can be used for both print and digital media, making them a great way to increase engagement with your audience."
      },
      {
        question: 'Are QR codes free?',
        answer:
          'QR codes are generally free to generate and use. There are multiple online platforms that allow users to generate QR codes for free. However, if you are looking for more advanced features and customization of the QR code, you may have to pay for a service. If you are searching for the best free QR code generator to get started, Flowcode offers robust customization and features for creators like logos, colors, and patterns.'
      },
      {
        question: 'How can I use QR codes for my business?',
        answer:
          "QR codes are a great way to market your business, connect directly with your audience offline, and increase customer engagement to your digital channels. They can be used to link customers directly to a PDF, your website, special offers, digital content, or any other information you wish to share. They are also easy to create and can be quickly scanned with most smart phones, making them great for customer interaction and collecting CRM. Whether you want to use codes to track customer behavior or engagement, QR codes help you to better understand customer preferences and develop better strategies for your business. To make a free QR code and start testing new ways to connect with your customers, use Flowcode's free QR code generator."
      },
      {
        question: 'How do QR codes work?',
        answer:
          'QR codes are a type of two-dimensional barcode that stores data in a structured, machine-readable format. These codes mostly consist of an assortment of black and white squares arranged in a specific pattern. However, some companies like Flowcode offer different shapes, patterns, and colors to make your QR code pop. When scanned with a smartphone camera, the code is able to quickly and accurately decode the data it holds and perform an action, such as opening a website, sending an email, or connecting to WiFi. There are many platforms that let you create a QR code, but Flowcode has the #1 free QR code generator because of the customization features you get. '
      },
      {
        question: 'Can I generate a QR code for free?',
        answer:
          'Yes, you can create a QR code for free. All you need is an internet connection and a free QR code generator. There are many free online QR code generators available, but Flowcode is the most powerful platform. Simply enter the data you want to encode (this could be a website, a PDF, an image, or any other digital destination) in the QR code into the generator, and it will generate a code for you. Customize the shape, pattern, and design of your code, then download it in various formats such as PNG, SVG, and EPS.'
      },
      {
        question: 'What is the safest online QR code generator?',
        answer:
          'The safest QR code generator is Flowcode. With GDPR, CCPA, and SOC2 compliance, the privacy and data of the people scanning your codes is always protected. With Flowcode, you can also expect robust security features, such as customizable access rules, secure encryption, and secure storage of the generated codes. With phishing and scam attempts on the rise, QR codes have become a vessel for bad actors. Good QR code generators should provide tools for mitigating such attempts. Through testing and validating the codes, as well as features for tracking code usage, companies like Flowcode are the most secure. '
      },
      {
        question: 'What is the best free QR code generator?',
        answer:
          'The best free QR code generator is Flowcode. There are many QR code platforms available, but most of them just offer free trials. Flowcode is a completely free online QR code generator that allows you to create unique QR codes. It is easy to use and provides a variety of features such as the ability to customize the design, pattern, color, and features the ability to track the code once it has been scanned. On top of this, Flowcode has an all-star customer support team who are available to help whenever you need it! '
      },
      {
        question: 'What is the disadvantage of free QR code?',
        answer:
          "Free QR codes typically are static — this means, when you produce a code, you can never change the online destination that it scans to. However, if you're looking for a free QR code with no downside, the clear answer is Flowcode. All of the codes are dynamic, meaning you can change the destination of your code even after you create it."
      }
    ],
    slice_type: 'faqs'
  },
  {
    primary: {
      header: 'Turn real-world experiences into digital consumers',
      subheader:
        'Used by over 10,000 businesses and 5 million\nindividuals across\n100+ countries with proven results.',
      button_label: 'Request a demo',
      button_href: { url: MarketingPageRoutes.CONTACT_SALES },
      button_variant: 'Primary'
    },
    items: [],
    slice_type: 'footer_attachement'
  }
]
